import React, {Fragment} from 'react';

import {List, Category} from 'units/navigation/models';
import {FEATURED} from 'units/services/constants';

import ListMFeatured from 'units/navigation/components/NavigationItems/ListMFeatured/ListMFeatured';
import ListMCards from 'units/navigation/components/NavigationItems/ListMCards/ListMCards';

type ListMProps = List & Category;

const ListM: React.FC<ListMProps> = ({category, navigationItems, type}) => (
    <Fragment>
        {category.slug === FEATURED ? (
            <ListMFeatured category={category} navigationItems={navigationItems} type={type} />
        ) : (
            <ListMCards navigationItems={navigationItems} type={type} />
        )}
    </Fragment>
);
export default ListM;
